export default __webpack_public_path__ + "media/images/features/jtb/highlight-13bbd786cb1e0305bd5c80fadcb2adbd.png";